<template>
  <div id="Main-App" class="card mt-1 border-0">
    <div :class="getActiveStep.classCss ? getActiveStep.classCss + ' card-body' : '0 card-body'" v-if="isWizard && !courseId && !thankYouPage">
        <div class="d-flex justify-content-between align-items-center">
            <h5 class="card-title text-secondary ms-1">Step {{getActiveStep.id + 1}} : {{translate('title', getActiveStep.title, getActiveStep.id)}}</h5>
        </div>
        <main class="w-contents">
            <div class="d-flex justify-content-center">
                <div v-if="isLoading" class="m-5 spinner-border" style="color: var(--primary);" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
            <!-- if step 0-->
          <div class="b-row" v-if="!isLoading && getActiveStep.id !== 1 && getActiveStep.id !== 2"
               :data-step="getActiveStep.id">
            <div class="btn col-sm-2 col-5 shadow-sm m-2 p-3"
                 v-for="(element, i) in translate('content', getActiveStep.data, getActiveStep.id)"
                 :key="i"
                 @click="getActiveStep.id === 1 ? multiSelect(element, i, getActiveStep.data) : selectElement(i, element)"
                 v-bind:class="{active : element.selected, 'element' : true}"
            >
              <div class="d-flex justify-content-center align-items-center" :data-step="getActiveStep.id">
                <span :class="element.Name ? element.Name + ' icon' : element.title + ' icon'"></span>
                <label :class="element.selected ? 'text-light' : 'text-secondary'"
                       class="card-text text-wrap" style="cursor: pointer">{{ element.Name ? element.Name : element.title }}</label>
              </div>
            </div>
          </div>
          <!-- if step 3-->
          <div class="b-row courses-types"
               v-if="!isLoading && getActiveStep.id === 2" >
            <div class="btn shadow-sm m-2 p-3"
                 v-for="(element, i) in translate('content', getActiveStep.data, getActiveStep.id)"
                 :key="i"
                 @click="getActiveStep.id === 1 ? multiSelect(element, i, getActiveStep.data) : selectElement(i, element)"
                 v-bind:class="{active : element.selected, 'element' : true}"
            >
              <div class="d-flex justify-content-center align-items-center" :data-step="getActiveStep.id">
                <span :class="element.Name ? element.Name + ' icon' : element.title + ' icon'"></span>
                <label :class="element.selected ? 'text-light' : 'text-secondary'"
                       class="card-text text-wrap" style="cursor: pointer">{{ element.Name ? element.Name : element.title }}</label>
              </div>
            </div>
          </div>
          <!-- if step 1 -->
            <div class="b-row" v-if="!isLoading && getActiveStep.id === 1" >
                <div class="btn  shadow-sm p-3" v-for="(element, i) in translate('content',
                definedHirarchy, getActiveStep.id)"
                    :key="i"
                    @click="getActiveStep.id === 1 ? multiSelect(element, i, getActiveStep.data) : selectElement(i, element)"
                    v-bind:class="{active : element.selected, 'element' : true, 'col-12': element.level === 'top',
                    'col-6': element.level === 'middle-first' || element.level === 'middle-second', 'col-3' : true }"
                >
                    <div class="d-flex justify-content-center align-items-center">
                      <span :class="element.Name ? element.Name + ' icon' : element.title + ' icon'"></span>
                        <label :class="element.selected ? 'text-light' : 'text-secondary'"
                               class="card-text text-wrap" style="cursor: pointer">{{ element.Name ? element.Name :
                            element.title }} {{ getDeal(element.level) }}</label>
                    </div>
                </div>

            </div>
            <div v-if="isLoadingCourses" class="d-flex align-items-center justify-content-center mt-3 mb-3">
                <div class="spinner-border" style="color: var(--primary);" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
            <!-- step 2  standard or intensive -->
            <div v-if="!isLoadingCourses && getActiveStep.id === 2 && (payload.session_type === 'standard' || payload.session_type === 'intensive')" class="mt-2 mb-2 ms-1">
                <div
                    v-if="getActiveStep.id === 2"
                    id="carouselExampleFade"
                    class="carousel carousel-fade carousel-dark slide mb-4"
                    data-bs-interval="false"
                    >
                    <!-- style="margin-left: 70px; margin-right: 70px;" -->
                    <v-select :clearable="false" class="pb-2 col-3 px-0"
                        v-model="selectedFilter"
                        placeholder="Filter courses"
                        :options="filterOptions" label="label"
                    />
                    <div class="mt-3 d-flex align-items-center justify-content-center" v-if="filteredCourses.length === 0">
                        <h5>No available courses</h5>
                    </div>
                    <div v-if="filteredCourses.length !== 0" class="carousel-inner" style="overflow: visible">
                        <ul
                            v-for="(month, index) in filteredCourses" :key="index"
                            :class="index === 0 ? 'active': ''"
                            class="mt-3 carousel-item inline-block ms-1 list-group list-group-flush courses-results"
                            >
                            <div class="row">
                                <h5 class="col">{{ month.month }} </h5>
                            </div>
                            <div v-for="(element, index) in month.courses" :key="index">
                                <li
                                    v-if="element.master_course.classroom_type === selectedFilter.value || !selectedFilter.value"
                                    :style="{'background-color': element.selected ? 'var(--primary)' : ''}"
                                    class="row shadow-sm border-0 mb-2 list-group-item d-flex justify-content-between align-items-center"
                                    >
                                    <div class="col-12 col-sm-4">
                                        <div class="d-block">
                                            <strong :style="{'color': !element.selected ? 'var(--primary)' : 'white'}" class="me-1">{{ element.Name }}</strong>
                                        </div>
                                        <small class="d-block">{{ formatDate(element.date_start) }} to {{ formatDate(element.date_end) }} ({{ element.hours }}h)</small>
                                        <!-- <small class="me-1 text-muted"></small> -->
                                    </div>
                                    <div class="col-5 col-sm-2">
                                      <span :class="element.master_course.classroom_type === 'classroom' ? 'bg-danger' : 'bg-success'" class="badge as-classroom">{{ element.master_course.classroom_type }}</span>
                                      <span class="claim-spot as-availability d-block" v-if="(element.available < 3 && element.available > 0 && element.available !== null)">{{ element.available }} places available</span>
                                        <span class="claim-spot as-availability d-block" v-if="element.available !== null && element.available <= 0">No places left</span>
                                    </div>
                                    <div class="col-5 col-sm-3">
                                        <strong class="d-block text-nowrap">{{ element.days }}</strong>
                                        <small class="text-muted">{{ element.time_from }} - {{ element.time_to }}</small>
                                    </div>
                                    <div class="col-7 d-flex justify-content-end align-items-center col-sm-3">
                                        <div class="d-flex justify-content-between">
                                            <span :style="{'color': !element.selected ? 'var(--primary)' : '#92434e'}" v-if="element.price">{{element.price}} Kr</span>
                                        </div>
                                        <button
                                            type="button"
                                            :disabled="element.full"
                                            @click="selectCourse(element, month.courses, payload.session_type)"
                                            class="btn rounded text-light ms-1" :class="!element.selected ? 'btn-primary' : 'btn-success'"
                                            >
                                        <span v-if="!element.full && element.available > 0 || element.available == null">{{ element.selected ? translate('select', 'Selected') : translate('select', 'Buy') }}</span>
                                        <span v-if="!element.full && element.available <= 0 && element.available != null">{{ element.selected ? translate('select', 'Selected') : translate('select', 'Waiting list') }}</span>
                                        <span v-if="element.full">{{ 'Full group' }}</span>
                                        </button>
                                    </div>
                                </li>
                            </div>
                        </ul>
                    </div>
                    <button v-if="courses.length > 1 && filteredCourses.length !== 0" class="carousel-control-prev" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="prev" style="left: 1291px; top: -77px; width: 5%">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                    </button>
                    <!-- style="margin-right: -140px;" -->
                    <button v-if="courses.length > 1 && filteredCourses.length !== 0" class="d-inline carousel-control-next" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="next" style="right: -50px; top: -73px; width: 5%">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">{{translate('button', 'Next')}}</span>
                    </button>
                </div>
            </div>
            <div v-if="getActiveStep.id === 2 && payload.session_type === 'individual'" class="mt-3 ms-2">
                <div class="">
                    <div class="">
                        <h5 class="">{{translate('modal', 'Course price:')}} {{ individual.price }} NOK </h5>
                    </div>
                    <form @submit.prevent="">
                        <div class="row">
                            <div class="col-4 form-outline mb-4">
                                <label for="hours" class="form-label">{{translate('modal', 'Hours')}}</label>
                                <input required type="number" min="5" @input="getEndDate" v-model="individual.hours" class="form-control">
                                <small v-if="individual.hours < 5" class="text-danger">Hours must be greater than 5</small>
                            </div>
                            <div class="col-4 form-outline mb-4">
                                <label for="participants" class="form-label">{{translate('modal', 'Participants')}}</label>
                                <input required type="number" min="1" max="3" @input="getEndDate" v-model="individual.participants" class="form-control">
                                <small v-if="individual.participants > 3" class="text-danger">{{ 'Participants must not be greater than 3' }}</small>
                                <small v-if="individual.participants < 1" class="text-danger">{{ 'Participants must not be less than 1' }}</small>
                            </div>
                            <div class="col-4 form-outline mb-4">
                                <label for="participants" class="form-label">{{translate('modal', 'Course type')}}</label>
                                <v-select :clearable="false"
                                    v-model="individual.course_type"
                                    placeholder="Course type"
                                    :options="courseTypeOptions" label="label"
                                />
                            </div>
                            <div class="col-6 form-outline mb-4">
                                <label for="date_start" class="form-label">{{translate('modal', 'From time')}}</label>
                                <input required type="time" @change="getEndDate" v-model="individual.time_start" class="form-control">
                            </div>
                            <div class="col-6 form-outline mb-4">
                                <label for="date_start" class="form-label">{{translate('modal', 'To time')}}</label>
                                <input required type="time" @change="getEndDate" v-model="individual.time_end" class="form-control">
                            </div>
                            <div class="col-12 mb-4">
                                <label for="days" class="form-label d-block" placeholder="Days">{{translate('modal', 'Days')}}</label>
                                <div class="form-check form-check-inline">
                                    <input v-model="individual.days" @change="getEndDate" class="form-check-input" :class="individual.days.includes('mon') ? 'checked' : ''" type="checkbox" id="inlineCheckbox1" value="mo">
                                    <label class="form-check-label" for="inlineCheckbox1">{{translate('modal', 'Monday')}}</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input v-model="individual.days" @change="getEndDate" class="form-check-input" :class="individual.days.includes('tue') ? 'checked' : ''" type="checkbox" id="inlineCheckbox2" value="tu">
                                    <label class="form-check-label" for="inlineCheckbox2">{{translate('modal', 'Tuesday')}}</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input v-model="individual.days" @change="getEndDate" class="form-check-input" :class="individual.days.includes('wed') ? 'checked' : ''" type="checkbox" id="inlineCheckbox3" value="we">
                                    <label class="form-check-label" for="inlineCheckbox3">{{translate('modal', 'Wednesday')}}</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input v-model="individual.days" @change="getEndDate" class="form-check-input" :class="individual.days.includes('thu') ? 'checked' : ''" type="checkbox" id="inlineCheckbox4" value="th">
                                    <label class="form-check-label" for="inlineCheckbox4">{{translate('modal', 'Tursday')}}</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input v-model="individual.days" @change="getEndDate" class="form-check-input" :class="individual.days.includes('fri') ? 'checked' : ''" type="checkbox" id="inlineCheckbox5" value="fr">
                                    <label class="form-check-label" for="inlineCheckbox5">{{translate('modal', 'Friday')}}</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input v-model="individual.days" @change="getEndDate" class="form-check-input" :class="individual.days.includes('sat') ? 'checked' : ''" type="checkbox" id="inlineCheckbox6" value="sa">
                                    <label class="form-check-label" for="inlineCheckbox6">{{translate('modal', 'Saterday')}}</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input v-model="individual.days" @change="getEndDate" class="form-check-input" :class="individual.days.includes('sun') ? 'checked' : ''" type="checkbox" id="inlineCheckbox7" value="su">
                                    <label class="form-check-label" for="inlineCheckbox7">{{translate('modal', 'Sunday')}}</label>
                                </div>
                            </div>
                            <div class="col-6 form-outline mb-4">
                                <label for="date_start" class="form-label">{{translate('modal', 'Start date')}}</label>
                                <input required type="date" @change="getEndDate" max="2100-01-01" min="1900-01-01" v-model="individual.date_start" class="form-control">
                            </div>
                            <div class="col-6 form-outline mb-4">
                                <label for="date_date" class="form-label">{{translate('modal', 'End date')}}</label>
                                <input disabled required type="date" max="2100-01-01" min="1900-01-01" v-model="individual.date_end" class="form-control">
                            </div>
                        </div>
                        <div class="">
                            <div class="alert alert-danger" v-if="individualModalHasError">
                            Please make sur that all fields are properly filled
                            </div>
                            <!-- <button type="submit"
                                    class="btn btn-primary"
                                    data-bs-dismiss="modal"
                                    @click="saveUserPreferences"
                            >{{translate('modal', 'Save changes')}}</button> -->
                            <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{translate('modal', 'Close')}}</button> -->
                        </div>
                    </form>
                </div>
            </div>
            <!-- step 2  !standard or !intensive -->
            <div v-if="!isLoadingCourses && getActiveStep.id === 2 && payload.session_type !== 'standard' && payload.session_type !== 'intensive' && payload.session_type !== 'individual'">
                <v-select v-if="payload.session_type === 'conversation'" :clearable="false" class="pb-2 col-3 px-0"
                    v-model="selectedConvFilter"
                    :options="filterConvOptions" label="label"
                />
                <div class="mt-3 d-flex align-items-center justify-content-center" v-if="courses.length === 0">
                    <h5>No available courses</h5>
                </div>
                <ul v-if="courses.length !== 0" class="mt-3 inline-block ms-1 list-group list-group-flush courses-results">
                    <div v-for="(element, index) in courses" :key="index">
                        <li v-if="(element.hours === selectedConvFilter.value || selectedConvFilter.value === 'All')" class="row shadow-sm border-0 mb-2 list-group-item d-flex justify-content-between align-items-center">
                            <div class="row col-10">
                                <div class="col-12 col-sm-4">
                                    <div class="d-block">
                                        <strong style="color: var(--primary) !important" class="me-1">{{ element.Name }}</strong>
                                    </div>
                                    <small v-if="payload.session_type !== 'individual'" class="me-1 text-muted">{{ formatDate(element.date_start) }} to {{ formatDate(element.date_end) }} ({{ element.hours }}h)</small>
                                    <small v-else class="me-1 text-muted">({{ element.hours }}h)</small>
                                </div>
                              <div class="col-5 col-sm-2">
                                <span :class="element.master_course.classroom_type === 'classroom' ? 'bg-danger' : 'bg-success'" class="badge as-classroom">{{ element.master_course.classroom_type }}</span>
                                <span class="claim-spot as-availability d-block" v-if="element.available < 3 && element.available > 0">{{ element.selected ? translate('select', 'Selected') : translate('select', 'Waiting list') }}</span>
                                <span class="claim-spot as-availability d-block" v-if="element.available !== null && element.available <= 0">{{ element.selected ? translate('select', 'Selected') : translate('select', 'No places left') }}</span>
                              </div>
                                <div v-if="payload.session_type !== 'individual'" class="col-6 col-sm-6">
                                    <strong class="d-block text-nowrap">{{ element.days }}</strong>
                                    <small class="text-muted">{{ element.time_from }} - {{ element.time_to }}</small>
                                </div>
                            </div>
                            <div class="col-2 d-flex justify-content-end align-items-center">
                                <span :style="{'color': !element.selected ? 'var(--primary)' : '#92434e'}" v-if="element.price">{{element.price}} Kr</span>
                                <button type="button" @click="selectCourse(element, courses, payload.session_type)"
                                        class="btn text-light btn-sm ms-1 rounded"
                                        :class="!element.selected ? 'btn-primary' : 'btn-success'">
                                        <span>{{ element.selected ? 'Selected' : 'Select' }}</span>
                                </button>
                            </div>
                            <div v-if="payload.session_type === 'individual' && individualModalIsOpen "
                                class="modal fade "
                                :class="individualModalIsOpen ? ' show ' : ''"
                                :style="individualModalIsOpen ? 'display:block!important;' : ''"

                            >
                            </div>

                        </li>
                    </div>
                </ul>
            </div>
            <div v-if="!isLoadingCourses && getActiveStep.id === 2 && payload.session_type === 'summer'" class="d-flex justify-content-center align-items-center">
                <iframe src="https://forms.office.com/Pages/ResponsePage.aspx?id=hU_55dZUz0-A0AYk6_8D2gpt33R8C6tNkcXqiYGByA1UQ1BRVFcyNzJXWlNVSURaM1JRUFRTUloxRC4u" width="640" height="500" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
            </div>
        </main>

      <!-- helper -->
        <!-- <QuestionComponent v-for="(question, key) in getActiveStep.helper"
                        :QuestionData="question"
                        :key="question.question"
                        :questionId="key"
                        :step="getActiveStep.id"
                        @question_responses="listenPlacementTest"
                        class="mb-2 taketest"
        /> -->
        <!-- nav -->
        <div class="wizard-nav">
            <button @click="prevStep" v-if="getActiveStep.id > 0" class="btn btn-secondary m-1 inline">{{translate('button', 'Back')}}</button>
            <button @click="selectElement(3, selectedElementsm, true)" v-if="getActiveStep.id === 1"
                    :disabled="selectedLevels.length === 0" class="btn btn-primary">{{ translate('button', 'Next') }}</button>
            <button :disabled="summary.length === 0 && (!this.individual.date_date && !this.individual.date_end || !this.individual.time_start || !this.individual.time_end || this.individual.hours < 5 || this.individual.participants < 1 || this.individual.participants > 3 || this.individual.days.length < 0)" v-if="isLastStep" class="btn btn-primary " @click="registrationForm">{{translate('button', 'Sign up')}}</button>
        </div>

    </div>
    <TestComponent v-if="PlacementTest && !thankYouPage" :Test="Test" @question_responses="listenPlacementTest"/>
    <RegistrationComponent
        v-if="(Registration || courseId) && !thankYouPage"
        @return_wizard="listenSwitchWizard"
        @checkout="checkout"
        :is-loading="isLoadingReg"
        :courses="summary"
        :individual="individual"
        :type="payload.session_type"
        :error-message-reg="errorMessageReg"
        :error-message-log="errorMessageLog"
        :shallShowConfirmationStep="shallShowConfirmationStep"
        @reset-errorMessage="errorMessageLog = null; errorMessageReg = { email: [], dob: [], firstname: [], lastname: [] }"
        @ShowConfirmationStep="toggleConfirmationStep"
        @form_data="listenFormData"
        :already-registered="alreadyRegistered"
        @toggle-register="(val, err) => { alreadyRegistered = val; err && !val ? errorMessageLog = 'We cannot find an account with that email address' : errorMessageLog = '' }"
        @hide-login-register="loginRegister = false; alreadyRegistered = true"
        :register-replacer="registerReplacer"
        :login-register="loginRegister"
        @update-registration-error-message="val => errorMessageReg.email[0] = val"
        @onCouponData = "couponData"
        />
    <thank-you-page v-if="thankYouPage" :thank-you-page-content="thankYouPageContent" />
        <!-- @form_data="listenFormData" -->
  </div>
</template>

<script>
    import vSelect from 'vue-select'
		import jwt from 'jsonwebtoken'
    import TestComponent from "./TestComponent";
    import RegistrationComponent from "./components/RegistrationComponent";
    import ThankYouPage from './components/ThankYouPage.vue'
    // import QuestionComponent from "./components/QuestionComponent";
    import $ from 'jquery'
    // eslint-disable-next-line no-unused-vars
    import slick from 'slick-carousel'
    import "bootstrap"
    export default {
        name: "App",
        components: {
            vSelect,
            // QuestionComponent,
            RegistrationComponent,
            ThankYouPage,
            TestComponent,
        },
        mounted(){

          // Parse course(s) from data-course attribute
          this.courseIds = this.parseCoursesFromDataAttribute();

          // Set courseId for backward compatibility (first course)
          this.courseId = this.courseIds.length > 0 ? this.courseIds[0] : null;

          // Fetch course(s) if we have IDs
          if (this.courseIds.length > 0) {
            this.fetchMultipleCourses(this.courseIds);
          }

            if (this.testId) {
                return this.listenPlacementTest()
            }
            if (this.dataRank && this.dataLevel) {
                this.wizard[0].active = false
                this.wizard[2].active = true
                this.payload = { level: [parseInt(this.dataLevel, 0)], rank: this.dataRank, session_type: 'standard' }
                if (this.payload.rank === 'Intermediate') {
                    this.wizard[2].data = [
                        {title : 'Standard course', value: 'standard', selected: true},
                        {title : 'Intensive course', value: 'intensive'},
                        // {title : 'Individual course', value: 'individual'},
                        // {title : 'Summer course', value: 'summer'},
                        {title : 'Conversation course', value: 'conversation'},
                        {title : 'Grammar course', value: 'grammar'},
                    ]
                } else {
                    this.wizard[2].data = [
                        {title : 'Standard course', value: 'standard', selected: true},
                        {title : 'Intensive course', value: 'intensive', selected: false},
                        // {title : 'Individual course', value: 'individual', selected: false},
                        // {title : 'Summer course', value: 'summer', selected: false},
                        {title : 'Conversation course', value: 'conversation', selected: false},
                    ]
                }
                fetch(`${process.env.VUE_APP_BASEURI}/get/courses/registration`, {
                    method: 'post',
                    headers: {
                        'Accept': 'application/json, text/plain, */*',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(this.payload),
                })
                .then(response => response.json().then(resp => {
                    this.isLoadingCourses = false
                    this.filteredCourses = resp.courses
                    this.filteredCourses.forEach(course => course.selected = false)
                    this.courses = resp.courses
                    this.courses.forEach(course => course.selected = false)
                    } ))
            }
          this.loadCssByUrl('https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.css')
          this.loadCssByUrl('https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick-theme.min.css')
        },
        computed: {
            coursePrice() {
                if (this.individual.hours <= 9) return 990 * this.individual.hours + (this.individual.participants === 2 ? 300 : this.individual.participants === 3 ? 500 : 0 )
                if (this.individual.hours < 20) return 960 * this.individual.hours + (this.individual.participants === 2 ? 300 : this.individual.participants === 3 ? 500 : 0 )
                if (this.individual.hours < 30) return 945 * this.individual.hours + (this.individual.participants === 2 ? 300 : this.individual.participants === 3 ? 500 : 0 )
                if (this.individual.hours < 40) return 930 * this.individual.hours + (this.individual.participants === 2 ? 300 : this.individual.participants === 3 ? 500 : 0 )
                if (this.individual.hours < 50) return 915 * this.individual.hours + (this.individual.participants === 2 ? 300 : this.individual.participants === 3 ? 500 : 0 )
                return 900  * this.individual.hours + (this.individual.participants === 2 ? 300 : this.individual.participants === 3 ? 500 : 0 )
            },
            // get step with active attr
            getActiveStep : function(){
                let filtred = [];
                filtred = this.wizard.filter( (step, idx) => {
                    step.id = idx
                    return step.active
                })
                if (filtred.length > 0){
                    return filtred[0]
                }
                return filtred
            },
            isLastStep : function () {
                return this.getActiveStep.id >= this.wizard.length - 1
            },
            splitHelper : function () {
                return []
            },
            definedHirarchy : function (){
              if(this.wizard[1].data.length > 0){
                let top_id;
                let key = 0;
                let middlef_id;
                let middles_id;
                let final_array = [];
                this.wizard[1].data.map(function (leveldata){
                  if (leveldata.parent_id === null && leveldata.title!== 'C1'){ //@todo: exception
                    leveldata.level = 'top';
                    top_id = leveldata.id
                    final_array.push(leveldata)
                  }
                  return leveldata
                })
                this.wizard[1].data.map(function (leveldata){
                  if (leveldata.parent_id === top_id){
                    (key === 0) ? leveldata.level = 'middle-first' : leveldata.level = 'middle-second';
                    (key === 0) ? middlef_id = leveldata.id :  middles_id = leveldata.id
                    final_array.push(leveldata)
                    key++
                  }
                  return leveldata
                })
                this.wizard[1].data.map(function (leveldata){
                  if (leveldata.parent_id === middlef_id){
                    leveldata.level = 'middle-first-sub';
                    final_array.push(leveldata)
                  }
                  if (leveldata.parent_id === middles_id){
                    leveldata.level = 'middle-second-sub';
                    final_array.push(leveldata)
                  }
                  if(leveldata.title === 'C1'){
                    leveldata.level = 'top';
                    final_array.push(leveldata)
                  }
                  return leveldata
                })
                return final_array
              }else{
                return []
              }
            },
        },
        created() {
            const today = new Date()
            const dd = String(today.getDate()).padStart(2, '0')
            const mm = String(today.getMonth() + 1).padStart(2, '0') //January is 0!
            const yyyy = today.getFullYear();
            this.individual.date_start = yyyy + '-' + mm + '-' + dd
        },
        methods: {
          parseCoursesFromDataAttribute() {
            const el = document.querySelector('#placementtestapp');
            const courseAttr = el?.dataset?.course;

            if (!courseAttr) {
              console.warn('No data-course attribute found');
              return [];
            }

            // Check if it's a JSON array (starts with '[')
            if (courseAttr.trim().startsWith('[')) {
              try {
                // Multiple courses: "[25803, 25804, 25805]"
                const parsed = JSON.parse(courseAttr);
                if (Array.isArray(parsed)) {
                  console.log('📚 Multiple courses detected:', parsed);
                  return parsed;
                } else {
                  console.error('data-course is not an array:', parsed);
                  return [];
                }
              } catch (e) {
                console.error('Failed to parse data-course as JSON:', e);
                return [];
              }
            } else {
              // Single course: "25803"
              const courseId = parseInt(courseAttr);
              if (!isNaN(courseId)) {
                console.log('📖 Single course detected:', courseId);
                return [courseId];
              } else {
                console.error('Invalid course ID:', courseAttr);
                return [];
              }
            }
          },

          fetchMultipleCourses(courseIds) {
            if (!courseIds || courseIds.length === 0) {
              console.error('No course IDs to fetch');
              return;
            }

            console.log('🎓 Fetching', courseIds.length, 'course(s)');

            // Fetch all courses in parallel
            const promises = courseIds.map(id =>
                fetch(`${process.env.VUE_APP_BASEURI}/courses/get/${id}`)
                    .then(response => response.json())
            );

            Promise.all(promises).then(results => {
              this.summary = results.map(res => res.data);
              this.selectedCourses = this.summary.map(el => el.id);
              this.Registration = true;
              console.log('✅ Loaded courses:', this.summary);
            }).catch(error => {
              console.error('❌ Error fetching courses:', error);
            });
          },
            couponData(coupon) {
              this.coupon = coupon
            },
            getDeal(level) {
                if (level === 'top') return '(BEST DEAL)'
                if (level === 'middle-first') return '(GOOD DEAL)'
                if (level === 'middle-second') return '(GOOD DEAL)'
                return ''
            },
            getEndDate() {
                if (this.individual.date_start && this.individual.time_start && this.individual.time_end && this.individual.hours && this.individual.days.length > 0) {
                    const payload = {
                        date_start: this.individual.date_start,
                        days: this.individual.days.join(','),
                        time_from: this.individual.time_start,
                        time_to: this.individual.time_end,
                        hours: this.individual.hours,
                        participants: this.individual.participants,
                    }
                    fetch(`${process.env.VUE_APP_BASEURI}/calculate/individual/course`, {
                        method: 'post',
                        headers: {
                            'Accept': 'application/json, text/plain, */*',
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(payload),
                    }).then(response => {
                        response.json().then(res => {
                            this.individual.date_end = res.date_end.split(' ')[0]
                            this.individual.price = res.price
                        })
                    })
                }
            },
            testingThings(event, slick) {
            var slidesToShow = slick.slickGetOption("slidesToShow");
                if (slidesToShow % 2 == 0) {
                    // Even number of slides in Slick Carousel is incorrectly offset.
                    // Adjust active slides.
                    slick["$slides"][slick.slickCurrentSlide()].previousElementSibling.classList.add("slick-active")
                    slick["$slides"][slick.slickCurrentSlide()].nextElementSibling.classList.remove("slick-active")
                }
            },
            toggleConfirmationStep(value) {
                this.shallShowConfirmationStep = value
            },
            loadScriptByUrl(url){
              let script = document.createElement('script')
              // script.async = true
              script.type = "text/javascript"
              script.src = url
              document.head.appendChild(script)
            },
            loadCssByUrl(url){
              let linkcss = document.createElement('link')
              linkcss.rel = "stylesheet"
              linkcss.type = "text/css"
              linkcss.href = url
              document.head.appendChild(linkcss)
            },
            translate(type, text, step) {
                const el = document.querySelector('#placementtestapp')
                const language = {
                    fr: {
                        title: ['Sélectionner un niveau', 'sélectionner un ou plusieurs cours', 'Sélectionnez une séance'],
                        content: [
                            [
                                { title: 'Débutant', value: 'Beginner' },
                              { title: 'Intermédiaire', value: 'Intermediate' },
                              { title: 'Avancé', value: 'Advanced' }
                            ],
                            text,
                            [
                                { title: 'Cours standard', value: 'standard' },
                              { title: 'Cours intensif', value: 'intensive' },
                              { title: 'Cours individuel', value: 'individual' },
                              { title: 'Cours d\'été', value: 'summer' },
                              { title: 'Cours de conversation', value: 'conversation' }
                            ],
                        ],
                        button: { Next: 'suivant', Back: 'Retour', Signup: 'S\'inscrire' },
                        select: 'Sélectionner',
                        selected: 'Choisi',
                        modal: {
                            days: ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'],
                            Days: 'Jours',
                            attend: 'Comment voulez-vous suivre ce cours :',
                            startDate: 'Date de début',
                            endDate: 'Date de fin',
                            startTime: 'De',
                            endTime: 'à',
                            close: 'Fermer',
                            saveChanges: 'Sauvegarder',
                        },
                    }
                }
                if (el.dataset.lang === 'fr') {
                    if (type === 'title') return language.fr.title[step]
                    if (type === 'content') return language.fr.content[step]
                    if (type === 'button', text === 'Next') return language.fr.button.Next
                    if (type === 'button', text === 'Back') return language.fr.button.Back
                    if (type === 'button', text === 'Sign up') return language.fr.button.Signup
                    if (type === 'select', text === 'Select') return language.fr.select
                    if (type === 'select', text === 'Selected') return language.fr.selected
                    if (type === 'modal') {
                        if (text === 'How do you want to attend this course:') return language.fr.modal.attend
                        if (text === 'Start date') return language.fr.modal.startDate
                        if (text === 'End date') return language.fr.modal.endDate
                        if (text === 'Time start') return language.fr.modal.startTime
                        if (text === 'Time end') return language.fr.modal.endTime
                        if (text === 'Days') return language.fr.modal.Days
                        if (text === 'Monday') return language.fr.modal.days[0]
                        if (text === 'Tuesday') return language.fr.modal.days[1]
                        if (text === 'Wednesday') return language.fr.modal.days[2]
                        if (text === 'Thursday') return language.fr.modal.days[3]
                        if (text === 'Friday') return language.fr.modal.days[4]
                        if (text === 'Saterday') return language.fr.modal.days[5]
                        if (text === 'Sunday') return language.fr.modal.days[6]
                        if (text === 'Close') return language.fr.modal.close
                        if (text === 'Save changes') return language.fr.modal.saveChanges
                    }
                }
                return text
            },
            formatDate(dateTime) {
							if (dateTime) {
								const date = dateTime.split(' ')[0]
								const dd = date.split('-')[2]
								const mm = date.split('-')[1]
								const yyyy = date.split('-')[0]
								return `${dd}-${mm}-${yyyy}`
							}
							return ''
            },
            selectCourse(course, courses, sessionType) {
                if (sessionType === 'standard' || sessionType === 'intensive' || sessionType === 'individual') {
                    if (course.selected) return course.selected = false
                    courses.forEach(course => course.selected = false)
                    course.selected = true
                    // this.registrationForm()
                  this.individualModalIsOpen = true
                } else {
                    course.selected = !course.selected
                }
                this.summary = courses.filter(el => el.selected)
                this.selectedCourses = this.summary.map(el => el.id)
            },
            getSelectedCourses(element, courses) {
                this.selectedLevels = courses.filter(course => course.selected)
                    if (element.selected) {
                        if (courses.length - this.selectedLevels.length === 2) {
                            courses.forEach(course => {
                                if (!course.parent_id && course.id === element.id) { course.selected = true }
                            })
                        }
                        courses.forEach(course => {
                            if (course.parent_id === element.id) {
                                course.selected = true
                                this.getSelectedCourses(course, courses)
                            }
                            if (course.id !== element.id && course.selected && course.parent_id === element.parent_id) {
                                    courses.forEach(c => {
                                        if (c.id === element.parent_id) {
                                            c.selected = true
                                        }
                                    })
                                }
                        })
                    } else {
                        if (courses.length - this.selectedLevels.length === 1) {
                            courses.forEach(course => {
                                if (!course.parent_id && course.id === element.id) { course.selected = false }
                            })
                        }
                        courses.forEach(course => {
                            if (course.parent_id === element.id) {
                                course.selected = false
                                this.getSelectedCourses(course, courses)
                            }
                            if (course.selected && course.id === element.parent_id) {
                                course.selected = false
                            }
                        })
                    }
            },
            multiSelect(element, i, courses) {
                element.selected = !element.selected
                // element.active = !element.active
                if (this.getActiveStep.id === 1) {
                    this.getSelectedCourses(element, courses)

                }
            },
            saveUserPreferences(){
              //  if all fields are filled
              if(this.individual.days.length  === 0
                  || this.individual.date_start === null
                  || this.individual.date_end === null
                  || this.individual.time_start === null
                  || this.individual.time_end === null)
              {
                //this.summary =  []
                //this.courses.forEach(course => course.selected = false);
                this.individualModalHasError = true
              }else {
                this.individualModalIsOpen = false
                this.individualModalHasError = false
              }
            },
            resolveClassroomType(type) {
                if (type === 'Local classes') return 'classroom'
                if (type === 'Live online classes') return 'online'
                if (type === 'Hybrid classes') return 'hybrid'
            },
            selectElement : function (selectedId, selectedEl, next) {
                this.summary = []
                // console.log(selectedEl)
                // let wizardData = [... this.wizard]
                if (this.getActiveStep.id === 0) {
                    if (selectedEl.value === 'admission_letter') {
                        this.summary = [{ Name: 'Admission letter', hours: '96', price: '10995' }]
                        this.selectedCourses = [9999999]
                        this.isWizard = false
                        this.Registration = true
                        this.wizard[0].data.forEach(el => {
                            if (el.value !== selectedEl.value) {
                                return el.selected = false
                            }
                            return el.selected = true
                        })
                        return
                        // return this.nextStep()
                        // this.selectedCourses = this.summary.map(el => el.id)
                    }
                    this.isLoading = true
                    this.payload.rank = selectedEl.value
                    fetch(`${process.env.VUE_APP_BASEURI}/get/level/${selectedEl.value.toLowerCase()}`)
                    .then(response => {
                        response.json().then(res => {
                            this.isLoading = false
                            this.wizard[1].data = res.subLevels
                        })
                    })
                }
                if (this.getActiveStep.id === 1) {
                    if (next) {
                        this.payload.level = this.wizard[1].data.filter(el => el.selected).map(el => el.id)
                        this.isLoadingCourses = true
                        fetch(`${process.env.VUE_APP_BASEURI}/get/courses/registration`, {
                            method: 'post',
                            headers: {
                                'Accept': 'application/json, text/plain, */*',
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(this.payload),
                        })
                        .then(response => response.json().then(resp => {
                            this.isLoadingCourses = false
                            this.filteredCourses = resp.courses
                            this.filteredCourses.forEach(course => course.selected = false)
                            this.courses = resp.courses
                            this.courses.forEach(course => course.selected = false)
                            } ))

                    }
                    if (this.payload.rank === 'Intermediate') {
                        this.wizard[2].data = [
                            {title : 'Standard course', value: 'standard', selected: true},
                            {title : 'Intensive course', value: 'intensive'},
                            // {title : 'Individual course', value: 'individual'},
                            // {title : 'Summer course', value: 'summer'},
                            {title : 'Conversation course', value: 'conversation'},
                            {title : 'Grammar course', value: 'grammar'},
                        ]
                    } else {
                        this.wizard[2].data = [
                            {title : 'Standard course', value: 'standard', selected: true},
                            {title : 'Intensive course', value: 'intensive', selected: false},
                            // {title : 'Individual course', value: 'individual', selected: false},
                            // {title : 'Summer course', value: 'summer', selected: false},
                            {title : 'Conversation course', value: 'conversation', selected: false},
                        ]
                    }
                }
                // console.log(this.getActiveStep.id)
                if (this.getActiveStep.id === 2) {
                    if (selectedEl.value === 'summer') {
                        return window.location = process.env.VUE_APP_FORM
                    }
                    this.payload.session_type = selectedEl.value
                    if (this.payload.session_type !== 'individual') {
                        this.isLoadingCourses = true
                        fetch(`${process.env.VUE_APP_BASEURI}/get/courses/registration`, {
                            method: 'post',
                            headers: {
                                'Accept': 'application/json, text/plain, */*',
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(this.payload),
                        })
                        .then(response => response.json().then(resp => {
                            this.isLoadingCourses = false
                            this.courses = resp.courses
                            this.filteredCourses = resp.courses
                            } ))
                    }
                }
                if (this.getActiveStep.id !== 1) {
                    this.wizard.map( (step) => {
                        if(step.active){
                            step.data.map( (element, idx) => {
                                element.selected = false
                                if(idx === selectedId){
                                    element.selected = true
                                    return element;
                                }
                            })
                        }
                    })
                }
                setTimeout(()=>{
                    this.nextStep()
                }, 200)
            },
            nextStep : function () {
                let wizardData = [... this.wizard]
                let newStepId = this.getActiveStep.id + 1;
                if (typeof wizardData[newStepId] !== "undefined"){
                    wizardData[this.getActiveStep.id].active = false
                    wizardData[newStepId].active = true
                }
                // console.log(this.getActiveStep.id)
            },
            prevStep : function () {
                let wizardData = [... this.wizard]
                let newStepId = this.getActiveStep.id - 1;
                if (this.getActiveStep.id >= 0){
                    wizardData[this.getActiveStep.id].active = false
                    wizardData[newStepId].active = true
                    // this.wizard[1].data.forEach(course => course.selected = false)
                }
                // console.log(this.getActiveStep.id)
            },
            registrationForm : function(){
                if (this.payload.session_type === 'individual') {
                    this.summary = [
                        {
                          Name: 'Individual course',
                          hours: this.individual.hours,
                          price: this.individual.price,
                          master_course: { classroom_type: this.individual.course_type.value },
                          date_start: this.individual.date_start,
                          date_end: this.individual.date_end,
                          days: this.individual.days.join(','),
                          time_start: this.individual.time_start,
                          time_end: this.individual.time_end,
                        }
                    ]
                }
                localStorage.selectedCourses = JSON.stringify(this.selectedCourses)
                this.isWizard = false
                this.Registration = true
            },
            resolveResult(score) {
                if (this.getActiveStep.id === 0) {
                    if (score < 20) return { title: 'Beginner', value: 'beginner' }
                    if (score < 60) return { title: 'Intermediate', value: 'intermediate' }
                    return { title: 'Advanced', value: 'advanced' }
                } else {
                    if (score < 10) return this.wizard[1].data[0]
                    if (score < 25) return this.wizard[1].data[1]
                    if (score < 40) return this.wizard[1].data[2]
                    if (score < 65) return this.wizard[1].data[3]
                    if (score < 70) return this.wizard[1].data[4]
                    if (score < 80) return this.wizard[1].data[5]
                    return this.wizard[1].data[6]
                }
            },
            listenPlacementTest : function(data){
                if (this.testId) {
                    return fetch(`${process.env.VUE_APP_BASEURI}/placement-test/` + this.testId).then(response => { response.json().then( resp => {
                        this.Test = resp.data
                        this.PlacementTest = true
                        this.isWizard = false
                        //   this.$data.testTitle = resp.message
                    })
                    }).catch(console.error)
                }
                if(data.placementTest === true){
                    const testId = this.getActiveStep.id === 0 ? `${process.env.VUE_APP_PTESTLEVELID}` : `${process.env.VUE_APP_PTESTCOURSESID}`
                    fetch(`${process.env.VUE_APP_BASEURI}/placement-test/` + testId).then(response => { response.json().then( resp => {
                        this.Test = resp.data
                        this.PlacementTest = true
                        this.isWizard = false
                        //   this.$data.testTitle = resp.message
                    })
                    }).catch(console.error)
                }else {
                    this.PlacementTest = false
                    this.isWizard = true
                    let result = {}
                    result = this.resolveResult(parseInt(data.result))
                    // this.selectElement(this.getActiveStep.id, result)
                    if(this.getActiveStep.id === 1){
                      let topLevel = this.wizard[1].data.filter( course => {
                        return course.level === 'top'
                      })
                      this.multiSelect(topLevel[0], 5, this.getActiveStep.data)
                      this.payload.level = this.selectedLevels.map(level => {
                        return level.id
                      })
                      this.selectElement(3, topLevel[0], true)
                    }else {
                      this.selectElement(this.getActiveStep.id, result) // default action
                    }
                    //  skip steps 0 and 1, go to 2
                    // this.wizard.map((step, index) => {
                    //     step.active = false
                    //     if(index === 2){
                    //         step.active = true
                    //     }
                    // })
                }
            },
            listenSwitchWizard : function(data){
                if(data.isWizard === true){
                    this.isWizard = true
                    this.Registration = false
                }
            },
            checkout(data, action) {
                this.isLoadingReg = true
                const companyPaymentMethod = data.companyPaymentMethod
                delete data.companyPaymentMethod
                const checkoutURL = `${process.env.VUE_APP_CHECKOUT}`
                fetch(`${process.env.VUE_APP_BASEURI}/create-payment`, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json, text/plain, */*',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        user_data: data,
                        companyPaymentMethod,
                        courses: this.selectedCourses,
                        checkouturl : checkoutURL,
                        session_type: this.payload.session_type,
                        coupon: this.coupon,
                        preferences: {
                            date_start: this.individual.date_start,
                            date_end: this.individual.date_end,
                            time_from: this.individual.time_start,
                            time_to: this.individual.time_end,
                            days: this.individual.days.join(','),
                            hours: this.individual.hours,
                            participants: this.individual.participants,
                            price: this.individual.price,
                            classroom_type: this.individual.course_type.value,
                        },
                    }), //should be courses IDs
                })
                .then(response => {
                    if (response.ok) {
                        response.json().then(resp => {
                          // console.log(resp)
                          localStorage.setItem('orderDetails', JSON.stringify(resp.payment.orderDetails));
                            this.thankYouPage = false
                            if (resp.payment.paymentId === 'invoice') {
                              // return window.location.href = process.env.VUE_APP_REDIRECT_URL
                              this.thankYouPage = true // @todo:  go trought the thank you page (which has to host the affiliate ajax)
                              return this.thankYouPageContent = resp.thankYouMessage //todo: restored back
                            }
                          if (resp.payment.paymentId === 'wl') {
                            // waiting list
                            this.thankYouPage = true // @todo:  go trought the thank you page (which has to host the affiliate ajax)
                            return this.thankYouPageContent = resp.thankYouMessage //todo: restored back
                          }
                            localStorage.accessToken = resp.Token.accessToken
                            localStorage.setItem('userData', JSON.stringify(data));
                            if (resp.paymentGateway === 'mollie' && resp.payment.paymentId !== 'free' && resp.payment.paymentId !== 'invoice') {
                                window.location.href = resp.payment._links.checkout.href // go to payment page
                            } else {
                                if (!resp.payment.paymentId) {                         // from create-payments
                                    console.error('Error: Check output from create-payments');
                                    return;
                                }
                                // checkout.html is implemented in Step 3
                                if (resp.payment.paymentId !== 'free') {
                                    window.location = `${process.env.VUE_APP_CHECKOUT}?paymentId=` +
                                    resp.payment.paymentId + '&whoPayed=' + (action === 'login' ? 'student' : data.who_pays ? data.who_pays.code : null);
                                }
                                else {
                                    window.location.href = `${process.env.VUE_APP_WEBSITEURL}/login/${localStorage.accessToken}`; // @todo: "free courses" should go trought the thank you page (which has to host the affiliate ajax)
                                }
                            }
                            this.isLoadingReg = false // @todo: check and implement a loader for create payment (because it takes about 12 s to load)

                        })
                    }
                    else {
                        response.json().then(err => {
                            if (!err.success) {
                                if (err.errors) {
                                    if(err.errors['checkout.Consumer.ShippingAddress.PostalCode']){
                                      const postcodeErr = err.errors['checkout.Consumer.ShippingAddress.PostalCode'][0]
                                      this.errorMessageLog = postcodeErr
                                      // @todo : cover more cases: phone number / address / postalCode / city / country
                                    }
                                    this.errorMessageReg.dob = err.errors.dob ? err.errors.dob : []
                                    this.errorMessageReg.email = err.errors.email ? err.errors.email : []
                                    this.errorMessageReg.firstname = err.errors.firstname ? err.errors.firstname : []
                                    this.errorMessageReg.lastname = err.errors.lastname ? err.errors.lastname : []
                                    return this.shallShowConfirmationStep = false
                                }
                                if (err.message === 'Login credentials are invalid.') {
                                    this.errorMessageLog = err.message
                                    return this.shallShowConfirmationStep = false
                                }
                            }
                            this.errorMessageReg.message = err.message
                            this.isLoadingReg = false
                            this.shallShowConfirmationStep = false
                        })
                    }
                }).catch(err => {
                    this.errorMessageReg.message = err.message
                    this.isLoadingReg = false
                    return this.shallShowConfirmationStep = false
                })
            },
            listenFormData : function(data, action){
                this.isLoadingReg = true
                localStorage.action = action
                const URL = action === 'login' ? `${process.env.VUE_APP_BASEURI}/login` : `${process.env.VUE_APP_BASEURI}/register`
                fetch(URL, {
                    method: 'post',
                    headers: {
                        'Accept': 'application/json, text/plain, */*',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(data),
                })
                .then(response => {
                    if (response.ok) {
                        response.json().then(resp => {
													const decodedToken = jwt.decode(resp.accessToken)
													this.registerReplacer = decodedToken
													this.alreadyRegistered = false
													this.loginRegister = true
                        })
                    } else {
                        response.json().then(err => {
                            if (!err.success) {
                                if (err.errors) {
                                    this.errorMessageReg = err.errors
                                    return this.shallShowConfirmationStep = false
                                }
                                if (err.message === 'Login credentials are invalid.') {
                                    this.errorMessageLog = err.message
                                    return this.shallShowConfirmationStep = false
                                }
                            }
                            this.errorMessageReg.message = err.message
                            this.isLoadingReg = false
                            this.shallShowConfirmationStep = false
                        })
                    }
                }).catch(err => console.log(err))
            },
            submitData : function(){
                // this.wizard.forEach( element => {
                //     // console.log(element)
                // })
            }
        },
        props:{
            id: Number,
        },
        data(){
            return {
                coupon : null,
                loginRegister: false,
                registerReplacer: {},
                alreadyRegistered: true,
                thankYouPage: false,
                thankYouPageContent: null,
                courseTypeOptions: [
                    { label: 'Online based (ZOOM)', value: 'online' },
                    { label: 'Classroom based', value: 'classroom' },
                ],
                isLoadingReg: false,
                selectedFilter: { label: 'All', value: null },
                filteredCourses: [],
                filterOptions: [{ label: 'All', value: null }, { label: 'Online', value: 'online' }, { label: 'Local classroom', value: 'classroom' }],
                filterConvOptions: [{ label: 'All', value: 'All'}, {label: '8 Hours', value: '8'}, {label: '16 Hours', value: '16'}, {label: '32 Hours', value: '32'}],
                selectedConvFilter: { label: 'All', value: 'All'},
                shallShowConfirmationStep: false,
                settings: {
                  arrows: false,
                  dots: false,
                },
                courseId: document.querySelector('#placementtestapp').dataset.course,
                testId: document.querySelector('#placementtestapp').dataset.test,
                dataRank: document.querySelector('#placementtestapp').dataset.rank,
                dataLevel: document.querySelector('#placementtestapp').dataset.level,
                isLoading: false,
                isLoadingCourses: false,
                summary: [],
                days: [
                    { name: 'Monday', value: 'mon' },
                    { name: 'Tuesday', value: 'tue' },
                    { name: 'Wednesday', value: 'wed' },
                    { name: 'Tursday', value: 'tur' },
                    { name: 'Friday', value: 'fri' },
                    { name: 'Saturday', value: 'sat' },
                    { name: 'Sunday', value: 'sun' },
                ],
                individual: {
                    days: [],
                    price: 900,
                    date_start: null,
                    date_end: null,
                    time_start: null,
                    time_end: null,
                    hours: 5,
                    participants: 1,
                    course_type: { label: 'Classroom based', value: 'classroom' },
                },
                individualModalIsOpen: false,
                individualModalHasError: false,
                slicktriggred: false,
                courseIsSelected: false,
                courses: [],
                selectedCourses: [],
                courseIds: [],
                selectedLevels: [],
                errorMessageReg: {
                    message: null,
                    email: [],
                    dob: [],
                    firstname: [],
                    lastname: [],
                },
                errorMessageLog: null,
                payload: {
                    session_type: 'standard',
                },
                Test: [],
                step3data: [],
                PlacementTest : false,
                Registration : false,
                isWizard : true,
                wizard :  [
                    {
                        title : 'Select a Level',
                        classCss: 'stepOne',
                        helper : [{
                            question: 'Not sure? {1}',
                            fields: [
                                {
                                    id : 1,
                                    formType : 'link',
                                    options : {
                                        label : 'Test your Norwegian language comprehension level for free',
                                        url : 'https://www.alfaskolen.no',
                                    }
                                },
                            ],
                        }],
                        data : [
                            { title : 'Beginner', value : 'Beginner' },
                            { title : 'Intermediate', value : 'Intermediate'},
                            { title : 'Advanced', value : 'Advanced'},
                            { title : 'Admission letter', value: 'admission_letter' },
                        ],
                        active: true,
                    },
                    {
                        title : 'Select one or more courses',
                        classCss: 'stepTwo',
                        helper : [{
                            question: 'Not sure? {1}',
                            fields: [
                                {
                                    id : 1,
                                    formType : 'link',
                                    options : {
                                        label : 'Test your Norwegian language comprehension level for free',
                                        url : 'https://www.alfaskolen.no/resources/img/',
                                    }
                                },
                            ],
                        }],
                        data : [
                            // {title : 'A0 Basic'},
                            // {title : 'A1 Beginner'},
                            // {title : 'A2.1 Elementary'},
                            // {title : 'A2.2 Advanced'},
                        ],
                        active: false
                    },
                    {
                        title : 'Select a session',
                        classCss: 'stepTree',
                        data : [],
                        active: false,
                    },
                    // {
                    //     title : 'How do you want to attend the classes?',
                    //     data : [
                    //         {title : 'Local classes'},
                    //         {title : 'Live online classes'},
                    //         {title : 'Hybrid classes'},
                    //     ],
                    //     active: false
                    // },
                    // {
                    //     title : 'When do you want to start?',
                    //     data : [],
                    //     active: false
                    // },
                ]
            }
        },
        watch: {
          wizard: {
            handler(nv, /* ov */){
            //   console.log(nv[2].active)
            //   console.log(ov[2].active)
              if(nv[2].active || !this.slicktriggred){
                $(document).ready(function(){
                  $('.courses-types').not('.slick-initialized').slick({
                    centerMode: true,
                    centerPadding: '60px',
                    slidesToShow: 3,
                    responsive: [
                      {
                        breakpoint: 768,
                        settings: {
                          arrows: false,
                          centerMode: true,
                          centerPadding: '40px',
                          slidesToShow: 3
                        }
                      },
                      {
                        breakpoint: 480,
                        settings: {
                          arrows: false,
                          centerMode: true,
                          centerPadding: '40px',
                          slidesToShow: 1
                        }
                      }
                    ]
                  });
                  this.slicktriggred = true
                });
              }
            },
            deep: true
          }
        },
    }
</script>
<style scoped src="./assets/bootstrap.min.css"></style>
<style scoped>
  /*@import "./assets/bootstrap.min.css";*/
  .w-contents{}
  .element {
    display: inline-block;
    border: 1px solid var(--primary) !important;
    /* margin: 5px; */
    /* padding: 60px 30px; */
    cursor: pointer;
  }
  .element.active {
    background-color: var(--primary) !important;
  }
  .btn-primary {
      background-color: var(--primary) !important;
      /* background-color: #92434e !important; */
      border-color: var(--primary) !important;
  }
  .btn:focus{
    box-shadow:none !important;
  }
  .signup {
    padding: 10px 50px;
    background-color: var(--primary) !important;
    border: 1px solid var(--primary) !important;
    display: block;
    margin: 15px 0;
  }
  input:focus {
    box-shadow:none !important;
    border-color: var(--primary) !important;
  }
  .slick-arrow {
    background-color: var(--primary) !important;
  }
  .form-check-input.checked {
      background-color: var(--primary);
      border-color: var(--primary) !important;
  }
</style>
